import { render, staticRenderFns } from "./QuestionnaireView.vue?vue&type=template&id=a08f7e7e&scoped=true&"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f7e7e",
  null
  
)

export default component.exports